define('SageDotCom/Components/Content/DigitalNewsroom/DigitalNewsroomResults',["jquery",
    "underscore",
    "eventManager",
    "SageDotCom/Components/Pagination",
    "text!SageDotCom/Components/Templates/DigitalNewsroomResultsFilters.html",
    "text!SageDotCom/Components/Templates/DigitalNewsroomCard.html"],
    // ReSharper disable InconsistentNaming
    function ($, _, eventManager, pagination, _templateResultsFilters, _templateResourceCard) {
        function DigitalNewsroomResults(scope, navigator, div, itemsPerPageDesktop, itemsPerPageMobile, countLabel) {
            var $resultsFilterDiv = $(scope).find(".filter-pill-container");
            var $storiesCountLabelEl = $(scope).find(".filter-props .resources-count");
            var resizeTimer = null;
            var globalFilteredData = {};
            var itemsPerPage = $(scope).find(".digital-newsroom-results-wrapper .digital-newsroom").hasClass("is-mobile")
                ? itemsPerPageMobile
                : itemsPerPageDesktop;

            var wrapper = $(scope).find(".digital-newsroom-results-wrapper");
            var view = $(scope).find(".digital-newsroom-results-view");

            self.hide = function () {
                var digitalNewsroom = document.querySelector('[id^="digitalnewsroom-"]');
                view.css({ "visibility": "hidden" });
                if (digitalNewsroom) {
                    digitalNewsroom.style.display = 'block';
                }
            }
            
            function init() {
                view.css({ "visibility": "hidden" });
                wrapper.hide();

                eventManager.subscribe("digital-newsroom-filter-changed",
                    function (filteredData) {
                        globalFilteredData = filteredData;
                        var digitalNewsroomResults = document.querySelector('.digital-newsroom-results-wrapper');
                        var digitalNewsroom = document.querySelector('[id^="digitalnewsroomlisting-"]');

                        if (checkFilterIsApplied(globalFilteredData)) {

                            if (digitalNewsroom) {
                                digitalNewsroom.style.display = 'none';
                            }

                            if (digitalNewsroomResults) {
                                digitalNewsroomResults.style.display = 'block';
                            }

                            view.css({ "visibility": "hidden" });
                            addSpinner(wrapper);

                            // generate an underscore template for results page filters
                            var resultsFilterTemplate = _.template(_templateResultsFilters);
                            var html = "";

                            html += resultsFilterTemplate(filteredData);
                            $resultsFilterDiv.html(html);

                            eventManager.trigger("digital-newsroom-observe-videos");
                            eventManager.trigger("digital-newsroom-find-dupes");

                            pagination.init(scope,
                                _templateResourceCard,
                                navigator,
                                div,
                                filteredData.digitalNewsroomResultsData,
                                itemsPerPage);

                            $storiesCountLabelEl.html(countLabel.replace("##", filteredData["unfilteredCount"])
                                .replace("#", filteredData.digitalNewsroomResultsData.length));

                            removeSpinner(wrapper);
                            view.css({ "visibility": "visible" });
                            eventManager.trigger("invoke-lazy-load");

                            self.pillResizingFunc();
                        } else {
                            removeSpinner(wrapper);
                            view.css({ "visibility": "hidden" });

                            if (digitalNewsroomResults) {
                                digitalNewsroomResults.style.display = 'none';
                            }

                            if (digitalNewsroom) {
                                digitalNewsroom.style.display = 'block';
                            }
                        }
                    });
                
                eventManager.subscribe("digital-newsroom-filter-reset-clicked", function() {
                    self.hide();
                });

                eventManager.subscribe("digital-newsroom-results-reset-btn-clicked", function () {
                    self.hide();
                    eventManager.trigger("digital-newsroom-filter-reset");
                });

                eventManager.subscribe("digital-newsroom-results-pill-clear-clicked", function (filterName, filterIndex) {
                    if (typeof globalFilteredData[filterName] !== "undefined" && globalFilteredData[filterName].length > 0) {
                        globalFilteredData[filterName].splice(filterIndex, 1);
                        addSpinner(wrapper);
                        view.css({ "visibility": "hidden" });
                        eventManager.trigger("digital-newsroom-filter-result-page-change", globalFilteredData);
                    }
                });
            };

            $(scope).find(".digital-newsroom-results-view .filter-props").delegate(".reset-btn", "click", function() {
                eventManager.trigger("digital-newsroom-results-reset-btn-clicked");
                eventManager.trigger("digital-newsroom-find-dupes");
            });

            $resultsFilterDiv.delegate(".filter-pill", "click", function () {
                var filterName = $(this).find("p").attr("name");
                var filterIndex = $(this).find("p").attr("index");

                eventManager.trigger("digital-newsroom-results-pill-clear-clicked", filterName, filterIndex);
                eventManager.trigger("digital-newsroom-find-dupes");
            });
            
            //add 3 square spinner
            function addSpinner(context) {
                context.append("<div class='loader'></div>");
                var spinner = context.find(".loader");
                spinner.append("<div class='bounce bounce1'></div>");
                spinner.append("<div class='bounce bounce2'></div>");
                spinner.append("<div class='bounce bounce3'></div>");
            }

            function removeSpinner(context) {
                var spinner = context.find(".loader");
                spinner.remove();
            }

            function checkFilterIsApplied(data) {
                if (data["ContentType"].length < 1 && data["Subjects"].length < 1 && data["Year"].length < 1 && data["Month"].length < 1)
                    return false;
                 else 
                    return true;
            }

            self.pillResizingFunc = function () {
                if ($resultsFilterDiv.length > 0) {
                    var showUnder = true;
                    var titleContainer = $(scope).find(".digital-newsroom-results-view .title-Container");
                    var titleSection = titleContainer.find(".title");
                    var inHeadingPills = titleContainer.find(".filter-pill-container");
                    var underHeadingPills = $(scope).find(".digital-newsroom-results-view > .filter-pill-container");

                    if (document.body.clientWidth >= 768) {
                        inHeadingPills.show().css("visibility", "hidden");
                        underHeadingPills.show().css("visibility", "hidden");

                        //Available width is the title container - the outer width of the title
                        var availableWidth = titleContainer.width() - titleSection.outerWidth(true);

                        var totalOuterWidth = 0;
                        inHeadingPills.find(".filter-pill").each(function (i, el) {
                            totalOuterWidth = totalOuterWidth + $(el).outerWidth(true);
                        });
                        
                        if (availableWidth >= totalOuterWidth) {
                            showUnder = false;
                        }
                    }

                    if (!showUnder) {
                        underHeadingPills.hide();
                        inHeadingPills.show().css("visibility", "");
                        view.removeClass("force-row");
                    } else {
                        underHeadingPills.show().css("visibility", "");
                        inHeadingPills.hide();

                        underHeadingPills.css("margin-left", "0");
                        if (document.body.clientWidth < 768) {
                            var offset = underHeadingPills.offset();
                            if (offset.left > 0) {
                                var leftPos = 0 - offset.left;
                                underHeadingPills.css("margin-left", leftPos + "px");
                            }
                        }
                        
                        if (document.body.clientWidth >= 768 && document.body.clientWidth < 1080) {
                            view.addClass("force-row");
                        } else {
                            view.removeClass("force-row");
                        }
                    }
                }
            }

            $(window).on("resize orientationchange", function () {
                if (resizeTimer) {
                    clearTimeout(resizeTimer);
                }
                resizeTimer = setTimeout(self.pillResizingFunc, 200);
            });

            init();
        };

        return function initDigitalNewsroomResult(args) {
            return args.IsExperienceEditorEditing
                ? null
                : new DigitalNewsroomResults(args.scope,
                    args.navigator,
                    args.div,
                    args.itemsPerPageDesktop,
                    args.itemsPerPageMobile,
                    args.countLabel);
        };
    });
